
      import { FolkGunDB } from '@folkjs/labs/FolkGunDB';

      // DOM Elements
      const connectionStatus = document.getElementById('connectionStatus');
      const shareBtn = document.getElementById('shareBtn');
      const sendBtn = document.getElementById('sendBtn');
      const messageInput = document.getElementById('messageInput');
      const chatMessages = document.getElementById('chatMessages');
      const connectionLog = document.getElementById('connectionLog');

      // FolkGunDB instance
      let gunDB = null;

      // Log function
      function log(message, type = 'system') {
        const entry = document.createElement('div');
        entry.className = `log-entry ${type}`;
        entry.textContent = message;
        connectionLog.appendChild(entry);
        connectionLog.scrollTop = connectionLog.scrollHeight;
      }

      // Add message to chat
      function addMessageToChat(message, isSent) {
        const messageEl = document.createElement('div');
        messageEl.className = `message ${isSent ? 'sent' : 'received'}`;
        messageEl.textContent = message;
        chatMessages.appendChild(messageEl);
        chatMessages.scrollTop = chatMessages.scrollHeight;
      }

      // Generate a random room ID
      function generateRoomId() {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      }

      // Set up event listeners for FolkGunDB
      function setupEventListeners() {
        // Listen for messages
        gunDB.onMessage((data, sender) => {
          console.log('Received message data:', data);

          // Handle different data formats
          let content = 'undefined message';

          if (data && typeof data === 'object') {
            // If data is an object with content property
            if (data.content !== undefined) {
              content = data.content;
            } else {
              // Just use the whole object
              content = JSON.stringify(data);
            }
          } else if (data !== undefined) {
            // If data is a primitive value
            content = String(data);
          }

          // Add to chat
          addMessageToChat(content, false);

          // Log
          log(`Received: ${content}`, 'received');
        });

        // Note: peer events are no longer supported in the simplified class
      }

      // Send a message
      function sendMessage(message) {
        if (!gunDB) return;

        try {
          // Send the message using the simplified API
          gunDB.send(message);

          // Add to chat
          addMessageToChat(message, true);

          // Log
          log(`Sent: ${message}`, 'sent');

          // Clear input
          messageInput.value = '';

          return true;
        } catch (error) {
          log(`Send error: ${error.message}`, 'error');
          console.error('Send message error:', error);
          return false;
        }
      }

      // Create a room and generate share link
      async function createAndShareRoom() {
        try {
          // Update button state
          shareBtn.textContent = 'Generating...';
          shareBtn.disabled = true;

          // Generate a unique room ID
          const roomId = generateRoomId();
          log(`Creating room with ID: ${roomId}`);

          // Create FolkGunDB instance with debugging enabled
          gunDB = new FolkGunDB(roomId, undefined, 'https://gun-manhattan.herokuapp.com/gun', true);

          // Connect to the room
          await gunDB.connect();

          // Set up event listeners
          setupEventListeners();

          // Generate share link
          const shareUrl = gunDB.getShareLink();

          // Update the current URL hash
          window.location.hash = `#r=${roomId}`;

          // Copy to clipboard
          navigator.clipboard
            .writeText(shareUrl)
            .then(() => {
              log('Share link copied to clipboard');
              shareBtn.textContent = 'Copied Link';
            })
            .catch((err) => {
              log(`Failed to copy link: ${err.message}`, 'error');
              shareBtn.textContent = 'Link Created (See Console)';
              console.log('Share link:', shareUrl);
            });

          // Update status
          connectionStatus.textContent = 'Room Created';

          // Enable sending
          messageInput.disabled = false;
          sendBtn.disabled = false;

          log('Ready for messaging');
        } catch (error) {
          shareBtn.textContent = 'Create Link';
          shareBtn.disabled = false;
          log(`Error: ${error.message}`, 'error');
          console.error('Room creation error:', error);
        }
      }

      // Join an existing room
      async function joinRoom(roomId) {
        try {
          log(`Joining room: ${roomId}`);

          // Create FolkGunDB instance with debugging enabled
          gunDB = new FolkGunDB(roomId, undefined, 'https://gun-manhattan.herokuapp.com/gun', true);

          // Connect to the room
          await gunDB.connect();

          // Set up event listeners
          setupEventListeners();

          // Update status
          connectionStatus.textContent = 'Connected to Room';
          shareBtn.textContent = 'Connected';

          // Enable sending
          messageInput.disabled = false;
          sendBtn.disabled = false;

          log('Joined room successfully');
        } catch (error) {
          shareBtn.textContent = 'Create Link';
          shareBtn.disabled = false;
          log(`Join error: ${error.message}`, 'error');
          console.error('Room join error:', error);
        }
      }

      // Event listeners
      shareBtn.addEventListener('click', createAndShareRoom);

      sendBtn.addEventListener('click', () => {
        const message = messageInput.value.trim();
        if (message) {
          sendMessage(message);
        }
      });

      // Allow sending with Enter key
      messageInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          const message = messageInput.value.trim();
          if (message && !sendBtn.disabled) {
            sendMessage(message);
          }
        }
      });

      // Check URL hash for room info on load
      window.addEventListener('load', () => {
        checkHashAndJoinRoom();

        // Log connection status
        log('Ready to create or join a room');
        connectionStatus.textContent = 'Ready';
      });

      // Also check when hash changes (for when URL is updated in existing tab)
      window.addEventListener('hashchange', () => {
        checkHashAndJoinRoom();
      });

      // Function to check hash and join room if needed
      function checkHashAndJoinRoom() {
        if (window.location.hash.startsWith('#r=')) {
          const roomId = window.location.hash.substring(3);

          if (roomId && (!gunDB || gunDB.roomId !== roomId)) {
            // Disconnect from any existing room
            if (gunDB) {
              gunDB.disconnect();
            }

            // Disable share button during join
            shareBtn.disabled = true;

            // Join the room
            joinRoom(roomId);
          }
        }
      }
    